interface AddressProps {
	id:string,
	fullAddress:string,
	postcode:string,
	x:number,
	y:number
}

/**
	* Address class for the address search
	* 
	* @remarks
	* Used mainly in /views/popups/AddressTool
	* 
	* @param id				-	ID of the address
	* @param fullAddress	-	Full address
	* @param postcode		-	Postcode
	* @param x				-	x coordinate
	* @param y				-	y coordinate
*/
export default class Address {
	public id:string;
	public fullAddress:string;
	public postcode:string;
	public x:number;
	public y:number;
	
	constructor({id, fullAddress, postcode, x, y}:AddressProps) {
		this.id = id;
		this.fullAddress = fullAddress;
		this.postcode = postcode;
		this.x = x;
		this.y = y;
	}
}